<template>
  <div>

  </div>
</template>

<script>
  export default {
    mounted(){
      this.$store.state.transPanelMenu = (69 * 2) + 2;
    }
  }
</script>

<style lang="scss" scoped>

</style>